<div class="h-screen flex w-full">
    <div class="flex flex-1 flex-column surface-ground justify-content-center">
        <div class="flex justify-content-center">
            <img src="assets/layout/images/pages/accessDenied.png" alt="" />
        </div>
        <div class="flex flex-column gap-2 align-items-center">
            <h1 class="m-0 text-orange-600 font-semibold">ACCESS DENIED!</h1>
            <span class="text-700">Requested resource is not available.</span>
        </div>
        <div class="flex justify-content-center mt-6">
            <button (click)="route()" pButton pRipple type="button" label="BACK TO DASHBOARD"
                class="p-button-text bg-indigo-500 text-white"></button>
        </div>  
    </div>
    <div [style.background]="'url(assets/layout/images/pages/accessDenied-bg.jpg)'"
        class="hidden lg:flex flex-1 align-items-center justify-content-center bg-cover">
        <img src="assets/images/layout/logoxxx.png" alt="" />
    </div>
</div>
